module.exports = __webpack_public_path__ + "static/media/4.0534a5e8.jpg";